/**
 * 匿名身份：player token（localStorage）+ HMAC secret + 手动恢复码。
 * 首次访问由服务端下发；secret 仅下发一次。
 */
import { API_BASE } from './api';
import { detectRegion } from './region';

const TOKEN_KEY = 'dd_token';
const SECRET_KEY = 'dd_secret';
const RECOVERY_KEY = 'dd_recovery';

export interface ClientIdentity {
  token: string;
  secret: string | null;
  recovery: string | null;
  name: string;
}

interface MeResponse {
  token: string;
  secret?: string;
  recovery?: string;
  name?: string;
}

export async function ensureIdentity(): Promise<ClientIdentity> {
  const headers = new Headers();
  const existing = localStorage.getItem(TOKEN_KEY);
  if (existing) headers.set('Authorization', `Bearer ${existing}`);
  const r = await fetch(`${API_BASE}/me?region=${detectRegion()}`, { headers });
  if (!r.ok) throw new Error('GET /me failed');
  const j = (await r.json()) as MeResponse;
  localStorage.setItem(TOKEN_KEY, j.token);
  if (j.secret) localStorage.setItem(SECRET_KEY, j.secret);
  if (j.recovery) localStorage.setItem(RECOVERY_KEY, j.recovery);
  return {
    token: j.token,
    secret: localStorage.getItem(SECRET_KEY),
    recovery: localStorage.getItem(RECOVERY_KEY),
    name: j.name ?? '',
  };
}
